import styled from "styled-components";
import CONSTANT from "../../constants/constant";

const StyledLogo = styled.img`
  width: ${(props) => props.width || "100px"};
  height: ${(props) => props.height || "100px"};
  cursor: ${(props) =>
    props.variant === CONSTANT.VARIANT.SMALL ? "pointer" : "default"};
`;

export default StyledLogo;
